import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import DoDisturbOffRoundedIcon from '@mui/icons-material/DoDisturbOffRounded';
import DoDisturbOnRoundedIcon from '@mui/icons-material/DoDisturbOnRounded';
import { createBlockChatOutbound, createBlockMessagesOutbound } from '../../api/outbound/commonOutbounds';
import { MenuItemContainer } from '../../components/menuItemContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { ALL_PLAYER_BLOCKING_TYPES, BLOCKING_TYPE_LABELS } from '../../types/playerBlockingTypes';
const OUTBOUND_CREATORS = {
    chat: createBlockChatOutbound,
    private_messages: createBlockMessagesOutbound
};
export const PlayerBlockingMenuItems = ({ playerInfo, closeMenu }) => {
    const socketSend = useSocketSend();
    return (_jsx(_Fragment, { children: ALL_PLAYER_BLOCKING_TYPES.map((blockingType) => {
            const isBlocking = playerInfo.blockingTypes.includes(blockingType);
            const blockingTypeLabel = BLOCKING_TYPE_LABELS[blockingType];
            const label = isBlocking ? `Unblock ${blockingTypeLabel}` : `Block ${blockingTypeLabel}`;
            return (_jsx(MenuItemContainer, { label: label, svgIconComponent: isBlocking ? DoDisturbOffRoundedIcon : DoDisturbOnRoundedIcon, onClick: () => {
                    socketSend(OUTBOUND_CREATORS[blockingType](playerInfo.playerIdName.id, !isBlocking));
                }, closeMenu: closeMenu }, blockingType));
        }) }));
};
